import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTiltLeftVector = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={236}
    height={225}
    fill="none"
    {...props}
  >
    <path
      stroke="#EEEFFF"
      strokeWidth={3}
      d="M57.499 224c-25-36.5-30.004-37.234-33.393-59.326-4.236-27.614 22.433-39.413 28.084-52.335 4.521-10.339-2.683-20.15-6.85-23.763-7.625-3.608-15.007-5.345-22.146-11.704-3.047-.842-9.985-3.903-13.356-9.415-3.37-5.513-.68-7.248 1.086-7.426-18.76-34.652-2.266-45.951 7.39-51.856C29.192 1.525 47.964-6.732 69.47 24.233c1.102-1.276 4.07-2.58 7.12 2.408s2.8 12.864 2.294 16.18c2.407 9.252.59 16.614.326 25.046 1.317 5.356 6.767 16.239 18.03 16.926 14.078.859 36.734-17.502 59.384-1.147 18.12 13.084 55.778 91.221 77.447 126.66"
    />
  </svg>
);
export default SvgTiltLeftVector;
